import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpApiService} from './http-api.service';

@Injectable({
  providedIn: 'root'
})
export class TransportApiService {
  private readonly updateStatusFollowDistriEndpoint = 'transport/update_statut_suivi_distri';

  constructor(private httpApiService: HttpApiService) {
  }

  public updateStatusFollowDistri(cookies: string, idTransport: number, status: string): Observable<any> {
    const params = {
      id_transport: idTransport,
      status: status,
    };
    return this.httpApiService.post<any>(this.updateStatusFollowDistriEndpoint, params, cookies);
  }
}
